import Component from '../abstracts/Component';
import vex from 'vex-js';

export default class ModalComponent extends Component {
  get SELECTORS() {
    return {
      trigger: '[data-modal], .modal-trigger',
      container: '.vex',
      focusableEl: 'a, :input:not([type=hidden]), button, [tabindex], iframe, :input:not(.form-group__username)'
    };
  }

  get LIBRARIES_SELECTORS() {
    return {
      tab: '[data-tabs]',
      select: 'select'
    };
  }

  get CLASSES() {
    return {
      canScroll: 'can-scroll'
    };
  }

  constructor() {
    super();
    this.focusableEl = $(this.SELECTORS.focusableEl);
  }

  modalAfterOpen(vexInstance, closeText, overflow) {
    let $close =  $(vexInstance.closeEl);
    let $container = $(vexInstance.rootEl);
    let closeLabel = closeText;

    if (closeText) {
      $close.text(closeLabel).addClass('cta-close')
    }

    if (overflow === 'auto') {
      $('body').addClass(this.CLASSES.canScroll);
    }

    let $tabs = $container.find(this.LIBRARIES_SELECTORS.tab);
    if ($tabs.length > 0) {
      this.moduleLoader.loadBootstrapJsComponentAndExecute(
        'tab',
        module => {
          $(this.LIBRARIES_SELECTORS.tab).tab();
          this.log('Tab initialized');
        },
        error => {
          console.log('failed to load tabs ', error.stack);
        }
      );
    }

    let $select = $container.find(this.LIBRARIES_SELECTORS.select);

    //ADD ACCESSIBILITY PROPERTIES
    $container.attr('tabindex', -1).attr('role', 'dialog');
    $close.attr('role', 'button').attr('tabindex', 0);

    let $focusableEl = $container.find(this.SELECTORS.focusableEl);
    $focusableEl.first().focus();

    this.$off('keydown',$close);
    this.$on('keydown', function (e) {
      if (e.keyCode === 13)
        vex.close(vexInstance);
    },$close);
  }

  getDataConfig ($el) {
    try {
      switch (true) {
        case $el.siblings(".dataForm").length > 0:
          return {
            data: $el.siblings(".dataForm").serialize(),
          };
        case typeof $el.data('body') === "string":
          return {
            contentType: "application/json; charset=utf-8",
            data: JSON.parse($el.data('body')),
          };
        case !!$el.data('body'):
          return {
            contentType: "application/json; charset=utf-8",
            data: $el.data('body'),
          };
        default:
          return {};
      }
    } catch (e) {
      return {};
    }
  }

  openAjaxContent(el) {
    let ctx = this;
    let url = el.data('href') || el.attr('href');
    let title = el.data('title');
    let close = el.data('closeText');
    let overlayClass = el.data('overlayClass');
    let overflow = el.data('overflow');
    let dataEgonValidation = el.data('egonValidation');
    let method = el.data('method') || 'GET';
    let dataConfig = method.toUpperCase() === 'POST' ? this.getDataConfig(el) : null;

    $(el).addClass('disable-click');

    $.ajax(
      Object.assign(
        {
          type: method,
          url: url,
        },
        dataConfig,
      )
    ).then(resp => {
      let chunked = $(resp).find('[data-ajax-chunk]');

      if (typeof resp != 'object' && chunked.length) {
        resp = chunked.html();
      }

      vex.open({
        unsafeContent: this.wrappedContent(resp, title)[0].outerHTML,
        className: el.data('modalClass'),
        closeClassName: 'icon-close',
        afterOpen: function() {
          setTimeout(function() {
            $('body').trigger('formInitializeAll');
          }, 1000);
          ctx.modalAfterOpen(this, close, overflow);
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
          if (dataEgonValidation === true) {
            ctx.$emit(ctx.$customEvents.MODAL_EVENTS.egonValidation);
          }
        },
        afterClose: function() {
          $('body').removeClass(ctx.CLASSES.canScroll);
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
          $(el).removeClass('disable-click');
        },
        overlayClassName: overlayClass
      });
    });
  }

  openStaticContent(el) {
    let ctx = this;
    let title = el.data('title');
    let close = el.data('closeText');
    let content = $(el.data('modalId'))[0].outerHTML;

    $(el).addClass('disable-click');

    vex.open({
      unsafeContent: this.wrappedContent(content, title)[0].outerHTML,
      className: el.data('modalClass'),
      closeClassName: 'icon-close',
      afterOpen: function() {
        ctx.modalAfterOpen(this, close);
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
      },
      afterClose: function() {
        $('body').removeClass(ctx.CLASSES.canScroll);
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $(el).removeClass('disable-click');
      }
    });
  }

  openRemoteContent(conf) {
    let title = $(conf.unsafeContent).data('title');
    let close = $(conf.unsafeContent).data('closeText');
    let ctx = this;
    let classData = $(conf.unsafeContent).data('modalClass');
    if (conf.modalClass) {
      classData = conf.modalClass;
    }
    if (conf.canScroll) document.body.classList.add(this.CLASSES.canScroll);
    vex.open({
      unsafeContent: this.wrappedContent(conf.unsafeContent, title)[0].outerHTML,
      className: classData,
      closeClassName: 'icon-close',
      afterOpen: function() {
        ctx.modalAfterOpen(this, close);
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
      },
      afterClose: function() {
        $('body').removeClass(ctx.CLASSES.canScroll);
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
      }
    });
  }

  wrappedContent(content, title) {
    let container = $(`<div class="modal__content"></div>`);
    if (title) {
      let $header = $(`<div class="modal__header"><h2>${title}</div>`);
      container.append($header);
    } else {
      container.addClass('no-header')
    }
    if (content) {
      let $body = $(`<div class="modal__body">${content}</div>`);
      if($body.find('[data-componentpb]').length > 0) {
        $body.find('[data-componentpb]').each((index, elem)=> {
          this.importComponent(elem.dataset.componentpb);
        });
      }
      container.append($body);
    }
    return container;
  }

  bindEvents() {
    this.$on('click.modal', ({event}) => {
      let $el = $(event.currentTarget);
      if ($el.data("originalEvent") !== "run") {
        event.preventDefault();
      }

      if ($el.data('modalId') ) {
        this.openStaticContent($el);
      } else {
        this.openAjaxContent($el);
      }
    }, 'body', this.SELECTORS.trigger);

    this.$on(this.$customEvents.MODAL_EVENTS.show, ({payload}) => {
      this.openRemoteContent(payload);
    });
  }

  render() {
    this.bindEvents();
  }
}
